export default __webpack_public_path__ + "static/5-fc573acdf290b9d54cc4f20ad8299d74.png";